/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface Chamber
 */
export interface Chamber {
    /**
     * 
     * @type {number}
     * @memberof Chamber
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Chamber
     */
    x?: number;
    /**
     * 
     * @type {number}
     * @memberof Chamber
     */
    y?: number;
    /**
     * 
     * @type {string}
     * @memberof Chamber
     */
    $type?: ChamberTypeEnum;
}


/**
 * @export
 */
export const ChamberTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoArrayDetectorLayoutDtoChamberPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.ArrayDetectorLayoutDto+Chamber, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ChamberTypeEnum = typeof ChamberTypeEnum[keyof typeof ChamberTypeEnum];



/**
 * Check if a given object implements the Chamber interface.
 */
export function instanceOfChamber(value?: unknown): value is Chamber {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ChamberTypeEnum)[0];
}

export function ChamberFromJSON(json: any): Chamber {
    return ChamberFromJSONTyped(json, false);
}

export function ChamberFromJSONTyped(json: any, ignoreDiscriminator: boolean): Chamber {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'x': json['x'] == null ? undefined : json['x'],
        'y': json['y'] == null ? undefined : json['y'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ChamberToJSON(value?: Chamber | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'x': value['x'],
        'y': value['y'],
        '$type': value['$type'],
    });
}

